"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truthy = void 0;
function truthy(value) {
    return Boolean(value);
}
exports.truthy = truthy;
//# sourceMappingURL=truthy.js.map